import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { AcBadge } from '@ac/mobile-components/dist/components/badge';
import { Color, TextSize } from '@ac/mobile-components/dist/enums';
import {
  Styleable,
  Testable
} from '@ac/mobile-components/dist/interfaces/componentProps';

interface EtaEtdGuaranteedBadgeProps extends Styleable, Testable {}

const EtaEtdGuaranteedBadge: FC<EtaEtdGuaranteedBadgeProps> = (
  props: EtaEtdGuaranteedBadgeProps
) => {
  const { t } = useTranslation();
  const className = classNames('eta-etd-guaranteed-badge', props.className);

  return (
    <AcBadge
      style={props.style}
      className={className}
      badgeText={t('GLOBAL.ETA_ETD_GUARANTEED')}
      backgroundColor={Color.White}
      labelUppercase={false}
      borderColor={Color.Gray4}
      testSelector={props.testSelector}
      badgeTextSize={TextSize.Main3}
      fit={true}
    />
  );
};

export default memo(EtaEtdGuaranteedBadge);



// WEBPACK FOOTER //
// ./src/components/shared/EtaEtdGuaranteedBadge/EtaEtdGuaranteedBadge.tsx